module.exports = __webpack_public_path__ + "static/media/bullet.b157d603.svg";